import React, { useEffect } from "react";

const MetaTags = ({ title, description, image }) => {
    const desc = 'winee sports, ' + description.replace(/<[^>]*>/g, '').replace(/&[^;\s]+;/g, '');
    useEffect(() => {
        const removeExistingMetaTags = (name) => {
            const existingTags = document.querySelectorAll(`meta[name="${name}"], meta[property="${name}"]`);
            existingTags.forEach((tag) => tag.parentNode.removeChild(tag));
        };
        document.title = title
        // 기존 메타 태그 제거
        removeExistingMetaTags("description");
        removeExistingMetaTags("og:title");
        removeExistingMetaTags("og:description");
        removeExistingMetaTags("og:image");

        // 새로운 메타 태그 추가
        const addMetaTag = (name, content) => {
            const metaTag = document.createElement("meta");
            metaTag.setAttribute(name.startsWith("og:") ? "property" : "name", name);
            metaTag.setAttribute("content", content);
            document.head.appendChild(metaTag);
        };

        addMetaTag("description", desc);
        addMetaTag("og:title", title);
        addMetaTag("og:description", desc);
        addMetaTag("og:image", image);

        // 제목 업데이트
        document.title = title;
    }, [title, description, image]);

    return null;
};

export default MetaTags;

const setMetaTags = (title, description, image) => {
    const removeExistingMetaTags = (name) => {
        const existingTags = document.querySelectorAll(`meta[name="${name}"], meta[property="${name}"]`);
        existingTags.forEach((tag) => tag.parentNode.removeChild(tag));
    };
    document.title = title
    // 기존 메타 태그 제거
    removeExistingMetaTags("description");
    removeExistingMetaTags("og:title");
    removeExistingMetaTags("og:description");
    removeExistingMetaTags("og:image");

    // 새로운 메타 태그 추가
    const addMetaTag = (name, content) => {
        const metaTag = document.createElement("meta");
        metaTag.setAttribute(name.startsWith("og:") ? "property" : "name", name);
        metaTag.setAttribute("content", content);
        document.head.appendChild(metaTag);
    };

    addMetaTag("description", description);
    addMetaTag("og:title", title);
    addMetaTag("og:description", description);
    addMetaTag("og:image", image);

    // 제목 업데이트
    document.title = title;
}

export { setMetaTags }